import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Navbar } from './Navbar'
import { StageBanner } from './StageBanner'
import { buildVersion } from '../../env'

export function Layout() {
  const { t } = useTranslation()
  return (
    <div className="min-h-screen flex flex-col bg-brand-50">
      <StageBanner />
      <Navbar />
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-6">
        <Outlet />
      </main>
      <footer className="text-center text-xs text-brand-500 py-3 border-t border-brand-100">
        As Oy Vantaan Kilterinlinna &nbsp;·&nbsp;{' '}
        <a href="/lataus_kayttoehdot.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">
          {t('footer.terms')}
        </a> &nbsp;·&nbsp; {buildVersion}
      </footer>
    </div>
  )
}
